module.exports = __webpack_public_path__ + "img/m4Ship.a78c304c.png";